<template>
  <div class="dnn-officialsite" ref="app_container">
    <header class="nav">
      <HeaderBar></HeaderBar>
    </header>
    <section class="main">
      <router-view />
    </section>
    <footer class="footer" v-if="showFooter">
      <ContractUs
        v-if="showContactUs"
        v-scroll-animate="{ animation: 'fadeInUp' }"
      />
      <FooterDark />
    </footer>
  </div>
</template>
<script>
import HeaderBar from "../components/HeaderBar.vue";
import FooterDark from "../components/FooterDark.vue";
import ContractUs from "../components/ContractUs.vue";
export default {
  components: {
    HeaderBar,
    FooterDark,
    ContractUs,
  },
  mounted() {
    this.init();
  },
  methods: {
    //App.vue
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    init() {
      console.log("1-this.$route.path", this.$route);
    },
  },
  computed: {
    showFooter() {
      let routePath = ["/updateLog", "/updateLogDetail"]; // 所有页面都需要底部，所以改成不需要底部的页面将路由放置数组中
      let path = this.$route.path;
      return routePath.indexOf(path) === -1;
    },
    // showContactUs
    showContactUs() {
      console.log("2-this.$route.path", this.$route);
      const meta = this.$route.meta;
      console.log("meta", typeof meta.showContactUs);
      if (typeof meta.showContactUs == "boolean" && !meta.showContactUs) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss">
@import "../../src/assets/styles/index.css";
@import "~quill/dist/quill.snow.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.core.css";
#app {
  font-family: PingFang SC-Regular, PingFang SC;
  background: #f8f8f8;
}
.nav {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 999;
}

.main {
  margin-top: 80px;
}
</style>
